"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EditSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var EditSVG = function EditSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M19 7.3l-16 16a1.15 1.15 0 00-.14.17l-.08.17a.62.62 0 00-.07.23l-.71 5A1 1 0 003 30h.14l5-.71a1 1 0 00.41-.16l.17-.13 16-16zM29.7 6.58L25.42 2.3a1 1 0 00-.71-.3 1 1 0 00-.72.3l-3.56 3.57 5.71 5.71L29.7 8a1 1 0 000-1.42z"
  }));
};
exports.EditSVG = EditSVG;
EditSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(EditSVG);
exports.default = _default;